import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-batch-del-receive-lines',
  templateUrl: './batch-del-receive-lines.component.html',
  styleUrls: ['./batch-del-receive-lines.component.css']
})
export class BatchDelReceiveLinesComponent implements OnInit {
    batchDeliveryKeyno;

    purchInternalNo;

    purchLineKeyno;

    prodSizeColliKeyno;

    stockLocationKeyno;

    controlled;

    placed;

    public setting?: Setting;

    public itemsListReceiveLines: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.batchDeliveryKeyno = this.stateService.getStateParams()['batchdelivery_keyno'];
        this.purchInternalNo = this.stateService.getStateParams()['purch_internal_no'];
        this.purchLineKeyno = this.stateService.getStateParams()['purchline_keyno'];
        this.prodSizeColliKeyno = this.stateService.getStateParams()['prodsizecolli_keyno'];
        this.stockLocationKeyno = this.stateService.getStateParams()['stocklocation_keyno'];
        this.controlled = this.stateService.getStateParams()['controlled'];
        this.placed = this.stateService.getStateParams()['placed'];
    }

    private async loadSetting() {
        if (!!this.batchDeliveryKeyno && !!this.purchInternalNo && !!this.purchLineKeyno && !!this.prodSizeColliKeyno && !!this.stockLocationKeyno && !!this.controlled && !!this.placed) {
            this.setting = (await this.datatask.Post(1594, {
                batchdelivery_keyno: this.batchDeliveryKeyno,
                purch_internal_no: this.purchInternalNo,
                purchline_keyno: this.purchLineKeyno,
                prodsizecolli_keyno: this.prodSizeColliKeyno,
                stocklocation_keyno: this.stockLocationKeyno,
                controlled: this.controlled,
                placed: this.placed
            }))[0];
        }
    }

    private async loadReceiveLines() {
        if (!this.setting) return;

        this.itemsListReceiveLines = await this.datatask.Post(1595, this.setting);
    }

    private async init() {
        await this.loadSetting();
        this.loadReceiveLines();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    batchdelivery_keyno: string;
    searchtext: string;
    purch_internal_no: string;
    nbr_of_deviations: string;
    purchline_keyno: string;
    prodsizecolli_keyno: string;
    stocklocation_keyno: string;
    controlled: string;
    placed: string;
}
